import React, {useState} from 'react';
import { useEffect } from 'react';
import {useForm, Controller} from 'react-hook-form';


const RegisterBankDetails = (props) => {
  const {updateBankDetailsHandler, bankDetails} = props;
  
  const {
    register,
    formState: {errors},
    handleSubmit,
    setValue,
    getValues,
    control
  } = useForm();
  
  function submitstoreState(e) {
    console.log('submitstoreState:', e);
    updateBankDetailsHandler(e);
  }

  useEffect(() => {
    let beneficiaryName = (bankDetails && bankDetails.bankAccount) ? 
                          bankDetails.bankAccount.beneficiaryName : '';
    setValue('beneficiaryName', beneficiaryName);
    let businessName = (bankDetails && bankDetails.accountDetails) ? 
                          bankDetails.accountDetails.businessName : '';
    setValue('businessName', businessName);
    let businessType = (bankDetails && bankDetails.accountDetails) ? 
                          bankDetails.accountDetails.businessType : '';
    setValue('businessType', businessType);
    let ifscCode = (bankDetails && bankDetails.bankAccount) ? 
                          bankDetails.bankAccount.ifscCode : '';
    setValue('ifscCode', ifscCode);
    let accountNumber = (bankDetails && bankDetails.bankAccount) ? 
                          bankDetails.bankAccount.accountNumber : '';
    setValue('accountNumber', accountNumber);
  },[bankDetails])

  
  function RenderErrorMessage({errorMessage}) {
    return (
      <span
        className="border border-danger rounded-circle bg-danger text-white text-center mx-1 my-auto"
        style={{width: '2rem'}}
        title={errorMessage}
      >
        {'!'}
      </span>
    );
  }
  return (
    <form className="ps-form--auth" onSubmit={handleSubmit(submitstoreState)}>
      <label>Beneficiary Name:</label>
      <div className="w-100">
        <div
          className={`form-group d-flex ${
            errors.beneficiaryName && errors.beneficiaryName.type === 'required'
              ? 'border border-danger rounded'
              : ''
          }`}
        >
          <input
            className="form-control"
            {...register('beneficiaryName', {
              required: true,
              pattern: {
                value: /^[A-Za-z ]{1,20}$/,
                message: 'Enter a valid Beneficiary Name'
              }
            })}
            placeholder="Beneficiary Name"
          />
          {/* <Controller
            name="name"
            control={control}
            defaultValue=""
            render={({field: {onChange, value}, fieldState: {error}}) => (
              <input
                className="form-control"
                {...register('beneficiaryName', {
                  required: true,
                  value: {value},
                  onChange: {onChange},
                  pattern: {
                    value: /^[A-Za-z ]{1,20}$/,
                    message: 'Enter a valid Beneficiary Name'
                  }
                })}
                placeholder="Beneficiary Name"
              />
            )}
          /> */}
          {errors.beneficiaryName &&
            errors.beneficiaryName.type === 'pattern' && (
              <RenderErrorMessage
                errorMessage={errors.beneficiaryName.message}
              />
            )}
        </div>
      </div>
      <label>Business Name:</label>
      <div className="w-100">
        <div
          className={`form-group d-flex ${
            errors.businessName && errors.businessName.type === 'required'
              ? 'border border-danger rounded'
              : ''
          }`}
        >
          <input
            className="form-control"
            {...register('businessName', {
              required: true,
              pattern: {
                value: /^[A-Za-z ]{1,20}$/,
                message: 'Enter a valid Business Name'
              }
            })}
            placeholder="Business Name"
          />
          {errors.businessName && errors.businessName.type === 'pattern' && (
            <RenderErrorMessage errorMessage={errors.businessName.message} />
          )}
        </div>
      </div>
      <label>Business Type:</label>
      <div className="w-100">
        <div
          className={`form-group d-flex ${
            errors.businessType && errors.businessType.type === 'required'
              ? 'border border-danger rounded'
              : ''
          }`}
        >
          <input
            className="form-control"
            {...register('businessType', {
              required: true,
              pattern: {
                value: /^[A-Za-z ]{1,20}$/,
                message: 'Enter a valid Business Type'
              }
            })}
            placeholder="Business Type"
          />
          {errors.businessType && errors.businessType.type === 'pattern' && (
            <RenderErrorMessage errorMessage={errors.businessType.message} />
          )}
        </div>
      </div>
      <label>IFSC Code:</label>
      <div className="w-100">
        <div
          className={`form-group d-flex ${
            errors.ifscCode && errors.ifscCode.type === 'required'
              ? 'border border-danger rounded'
              : ''
          }`}
        >
          <input
            className="form-control"
            {...register('ifscCode', {
              required: true,
              pattern: {
                value: /^[0-9A-Za-z]{1,20}$/,
                message: 'Enter a valid IFSC Code'
              }
            })}
            placeholder="Bank IFSC Code"
          />
          {errors.ifscCode && errors.ifscCode.type === 'pattern' && (
            <RenderErrorMessage errorMessage={errors.ifscCode.message} />
          )}
        </div>
      </div>
      <label>Bank Account Number:</label>
      <div className="w-100">
        <div
          className={`form-group d-flex ${
            errors.accountNumber && errors.accountNumber.type === 'required'
              ? 'border border-danger rounded'
              : ''
          }`}
        >
          <input
            className="form-control"
            {...register('accountNumber', {
              required: true,
              pattern: {
                value: /^[0-9A-Za-z]{1,20}$/,
                message: 'Enter a valid Account Number'
              }
            })}
            placeholder="Bank Account Number"
          />
          {errors.accountNumber && errors.accountNumber.type === 'pattern' && (
            <RenderErrorMessage errorMessage={errors.accountNumber.message} />
          )}
        </div>
      </div>

      <div className="w-100">
        <button className="btn btn-dark w-100" type="submit">
          {'Update'}
        </button>
      </div>
    </form>
  );
};

export default RegisterBankDetails;
